import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "max-w-3xl mx-auto" }
const _hoisted_2 = { class: "mt-10 max-w-2xl" }
const _hoisted_3 = { class: "flex items-center gap-4 mt-6 text-sm/6" }
const _hoisted_4 = { class: "flex items-center gap-1" }
const _hoisted_5 = { class: "mt-16" }
const _hoisted_6 = { class: "max-w-2xl mt-16" }

import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import { computed } from "vue";
import type { CenteredProps } from "./CenteredProps";
import Feature from "@/views/blocks/shared/section/features/Feature.vue";
import Features from "@/views/blocks/shared/section/features/Features.vue";
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";

// Import shared components
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import Image from "@/views/blocks/shared/section/media/image/Image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Centered',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    backgroundColor: styleValues.value.background
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!dataValues.value.tag.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 0,
                  blockId: _ctx.block.id,
                  fieldName: "tag"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Heading, {
                      text: dataValues.value.tag.data.text,
                      tag: dataValues.value.tag.data.tag,
                      textColor: styleValues.value.brand,
                      class: "text-base/7 mb-2"
                    }, null, 8, ["text", "tag", "textColor"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true),
            (!dataValues.value.title.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 1,
                  blockId: _ctx.block.id,
                  fieldName: "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Heading, {
                      text: dataValues.value.title.data.text,
                      tag: dataValues.value.title.data.tag,
                      textColor: styleValues.value.text,
                      class: "text-4xl lg:text-5xl mb-6"
                    }, null, 8, ["text", "tag", "textColor"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true),
            (!dataValues.value.description.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 2,
                  blockId: _ctx.block.id,
                  fieldName: "description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Paragraph, {
                      text: dataValues.value.description.data.text,
                      textColor: styleValues.value.text,
                      class: "text-xl/8 opacity-70"
                    }, null, 8, ["text", "textColor"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.topText.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    fieldName: "topText"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.topText.data.text,
                        textColor: styleValues.value.text,
                        class: "text-base/7 opacity-70"
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              _createVNode(Features, { class: "mt-8 max-w-xl" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.features.data.items, (feature) => {
                    return (_openBlock(), _createBlock(EditableElement, {
                      key: feature.id,
                      blockId: _ctx.block.id,
                      fieldName: `features_${feature.id}`,
                      hideable: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(Feature, {
                          title: feature.title,
                          description: feature.description,
                          iconSrc: feature.iconSrc,
                          titleTextColor: styleValues.value.text,
                          descriptionTextColor: styleValues.value.text
                        }, null, 8, ["title", "description", "iconSrc", "titleTextColor", "descriptionTextColor"])
                      ]),
                      _: 2
                    }, 1032, ["blockId", "fieldName"]))
                  }), 128))
                ]),
                _: 1
              }),
              (!dataValues.value.bottomText.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    blockId: _ctx.block.id,
                    fieldName: "bottomText"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.bottomText.data.text,
                        textColor: styleValues.value.text,
                        class: "text-base/7 mt-8 opacity-70"
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.secondaryTitle.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 2,
                    blockId: _ctx.block.id,
                    fieldName: "secondaryTitle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, {
                        text: dataValues.value.secondaryTitle.data.text,
                        tag: dataValues.value.secondaryTitle.data.tag,
                        textColor: styleValues.value.text,
                        class: "text-3xl mt-16"
                      }, null, 8, ["text", "tag", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.secondaryDescriptionOne.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 3,
                    blockId: _ctx.block.id,
                    fieldName: "secondaryDescriptionOne"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.secondaryDescriptionOne.data.text,
                        textColor: styleValues.value.text,
                        class: "text-base/7 mt-6 opacity-70"
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.testimonial.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 4,
                    blockId: _ctx.block.id,
                    fieldName: "testimonial"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "mt-10 pl-9 border-l",
                        style: _normalizeStyle({
                                borderColor: styleValues.value.brand,
                            })
                      }, [
                        _createVNode(Paragraph, {
                          text: dataValues.value.testimonial.data.text,
                          textColor: styleValues.value.text,
                          class: "text-base/7 italic"
                        }, null, 8, ["text", "textColor"]),
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(Image, {
                            src: dataValues.value.testimonial.data.personImageSrc,
                            alt: dataValues.value.testimonial.data.personName,
                            class: "w-6 h-6 rounded-full"
                          }, null, 8, ["src", "alt"]),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(Paragraph, {
                              text: dataValues.value.testimonial.data.personName,
                              textColor: styleValues.value.text,
                              class: "font-semibold"
                            }, null, 8, ["text", "textColor"]),
                            (
                                            dataValues.value.testimonial.data.personName &&
                                            dataValues.value.testimonial.data.personPosition
                                        )
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  style: _normalizeStyle({ color: styleValues.value.text })
                                }, " - ", 4))
                              : _createCommentVNode("", true),
                            _createVNode(Paragraph, {
                              text: dataValues.value.testimonial.data.personPosition,
                              textColor: styleValues.value.text,
                              class: "opacity-70"
                            }, null, 8, ["text", "textColor"])
                          ])
                        ])
                      ], 4)
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.secondaryDescriptionTwo.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 5,
                    blockId: _ctx.block.id,
                    fieldName: "secondaryDescriptionTwo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.secondaryDescriptionTwo.data.text,
                        textColor: styleValues.value.text,
                        class: "text-base/7 mt-10 opacity-70"
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (!dataValues.value.image.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    fieldName: "image"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Image, {
                        src: dataValues.value.image.data.src,
                        alt: dataValues.value.image.data.alt,
                        class: "w-full rounded-xl aspect-[16/9] object-cover"
                      }, null, 8, ["src", "alt"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.infoNote.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    blockId: _ctx.block.id,
                    fieldName: "infoNote"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center gap-2 mt-4",
                        style: _normalizeStyle({
                                color: styleValues.value.text,
                            })
                      }, [
                        _cache[0] || (_cache[0] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 20 20",
                          fill: "currentColor",
                          "aria-hidden": "true",
                          class: "w-5 h-5"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z",
                            "clip-rule": "evenodd"
                          })
                        ], -1)),
                        _createVNode(Paragraph, {
                          text: dataValues.value.infoNote.data.text,
                          textColor: styleValues.value.text,
                          class: "text-sm/6 opacity-70"
                        }, null, 8, ["text", "textColor"])
                      ], 4)
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (!dataValues.value.tertiaryTitle.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    fieldName: "tertiaryTitle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, {
                        text: dataValues.value.tertiaryTitle.data.text,
                        tag: dataValues.value.tertiaryTitle.data.tag,
                        textColor: styleValues.value.text,
                        class: "text-2xl mb-6"
                      }, null, 8, ["text", "tag", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.tertiaryDescriptionOne.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    blockId: _ctx.block.id,
                    fieldName: "tertiaryDescriptionOne"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.tertiaryDescriptionOne.data.text,
                        textColor: styleValues.value.text,
                        class: "text-base/7 mb-8 opacity-70"
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.tertiaryDescriptionTwo.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 2,
                    blockId: _ctx.block.id,
                    fieldName: "tertiaryDescriptionTwo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.tertiaryDescriptionTwo.data.text,
                        textColor: styleValues.value.text,
                        class: "text-base/7 opacity-70"
                      }, null, 8, ["text", "textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "backgroundColor"]))
}
}

})